import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: theme => css`
    width: 100%;
    padding-right: ${theme.spacing.xxs};
    padding-left: ${theme.spacing.xxs};
    margin-right: auto;
    margin-left: auto;
    max-width: calc(100% - ${theme.spacing.md});

    @media (min-width: ${theme.grid.breakpoint.sm}) {
      max-width: calc(100% - ${theme.spacing.xs});
    }

    @media (min-width: ${theme.grid.breakpoint.lg}) {
      max-width: calc(${theme.grid.breakpoint.lg} - ${theme.spacing.lg});
    }

    @media (min-width: ${theme.grid.breakpoint.xl}) {
      max-width: calc(1280px - ${theme.spacing.lg});
    }
  `,
})

export default useStyles
